export function getAuth(): string | null {
	return localStorage.getItem('token')
}

export function clearAuth(): void {
	localStorage.clear()
}
